'use client';

import type { AnchorHTMLAttributes } from 'react';
import { twMerge as tw } from 'tailwind-merge';

interface LinkButtonSecondaryProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  className?: string;
}

const LinkButtonSecondary = ({ href, className, children, ...props }: LinkButtonSecondaryProps) => {
  return (
    <a
      href={href}
      className={tw(
        'border-primary-dark dark:border-primary-light hover:bg-primary-light dark:hover:bg-primary hover:border-primary-light dark:hover:border-primary inline-flex items-center justify-center rounded-xl border-2 bg-white px-7 py-3.5 font-bold tracking-wide text-gray-800 no-underline transition-all duration-300 hover:-translate-y-1 hover:text-[#000000] hover:shadow-lg active:-translate-y-px dark:bg-gray-900 dark:text-white dark:hover:text-white',
        className,
      )}
      {...props}
    >
      {children}
    </a>
  );
};

export default LinkButtonSecondary;
